import React, { createContext, useContext } from "react";
import { MsalProvider } from "@azure/msal-react";
import { ConvexProviderWithAuth, ConvexReactClient } from "convex/react";
import { msalInstance } from "./msalConfig";
import { useConvexMsalAuth } from "./useConvexMsalAuth";
import { useTeamsSSO } from "./useTeamsSSO";

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string);

interface TeamsContext {
  isInTeams: boolean;
  isTeamsInitializing: boolean;
}

const TeamsCtx = createContext<TeamsContext>({ isInTeams: false, isTeamsInitializing: true });

export function useTeamsContext() {
  return useContext(TeamsCtx);
}

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { isInTeams, isInitializing } = useTeamsSSO();

  return (
    <TeamsCtx.Provider value={{ isInTeams, isTeamsInitializing: isInitializing }}>
      <MsalProvider instance={msalInstance}>
        <ConvexProviderWithAuth client={convex} useAuth={useConvexMsalAuth}>
          {children}
        </ConvexProviderWithAuth>
      </MsalProvider>
    </TeamsCtx.Provider>
  );
}
